import { SeekPassIconVerified } from '@seek/certsy-ui';
import { useTranslations } from '@vocab/react';
import {
  Box,
  Columns,
  Column,
  IconNewWindow,
  Text,
  TextLink,
} from 'braid-design-system';
import type { FC } from 'react';

import { useAppConfig } from 'src/constants/AppConfig/AppConfigProvider';

import translations from './.vocab';

export const VerifiedCredentials: FC<{
  onClickLearnHowCredentialsAreVerified: () => void;
}> = ({ onClickLearnHowCredentialsAreVerified }) => {
  const { locale, router, site } = useAppConfig();
  const { t } = useTranslations(translations);

  return (
    <Columns space="xxsmall" data={{ testid: 'verified-credentials' }}>
      <Column width="content">
        <Text size="xsmall">
          <SeekPassIconVerified />
        </Text>
      </Column>
      <Column>
        <Text size="small">
          {t(
            'Verified credentials can help you assess with confidence. However, as an employer you remain responsible for ensuring candidates meet legal requirements.',
          )}
        </Text>
        <Box paddingTop="medium">
          <Text size="small">
            <TextLink
              href={router.seekPassFindOutMore({ site, locale })}
              onClick={onClickLearnHowCredentialsAreVerified}
              target="_blank"
              rel="noopener"
              icon={<IconNewWindow />}
              iconPosition="trailing"
            >
              {t('Learn how credentials are verified')}
            </TextLink>
          </Text>
        </Box>
      </Column>
    </Columns>
  );
};
